import { deflate } from "./compress";

const init = async () => {
  const $ = (sel) => document.querySelector(sel);

  const left = $(".left");
  const right = $(".right");
  const copy = $(".copy-link");
  const clipboard = $(".clipboard");
  const totalLength = $(".total-length");

  left.value = `You look nice, please have this bee 🐝. \n\nPaste text/markup here.`;

  const updateUI = (url) => {
    right.src = url;
    clipboard.value = url;
    totalLength.innerText = `${url.length || 0} characters`;

    if (url.length > 3900) {
      totalLength.classList.add("error");
    } else {
      totalLength.classList.remove("error");
    }
  };

  const getValueForInput = (input) =>
    Promise.resolve(input.value)
      .then(deflate)
      .then(
        (encodedValue) => `${location.origin}/index.html?c=${encodedValue}`
      );

  const handleLeftInput = (e) =>
    getValueForInput(e.currentTarget).then(updateUI);

  left.addEventListener("keyup", handleLeftInput);

  const handleCopyClick = () => {
    clipboard.select();
    document.execCommand("copy");
  };

  copy.addEventListener("click", handleCopyClick);

  getValueForInput(left).then(updateUI);
};

if (document.readyState === "interactive") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
